// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-copyright_root__WjqDf","brand":"footer-copyright_brand__MhAsq","copyText":"footer-copyright_copyText__FxDst"};